import React from 'react';
import { motion } from 'framer-motion';

const HalalCertificationBadge = () => {
  const badgeVariants = {
    initial: { 
      scale: 0,
      rotate: -180,
      opacity: 0
    },
    animate: { 
      scale: 1,
      rotate: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 200,
        damping: 20,
        duration: 1.5
      }
    }
  };

  const ribbonVariants = {
    initial: { scaleX: 0 },
    animate: { 
      scaleX: 1,
      transition: {
        delay: 0.8,
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  const textVariants = {
    initial: { opacity: 0, y: 10 },
    animate: { 
      opacity: 1, 
      y: 0,
      transition: {
        delay: 1.2,
        duration: 0.5
      }
    }
  };

  return (
    <motion.div
      variants={badgeVariants}
      initial="initial"
      animate="animate"
      className="fixed top-20 right-4 z-40"
    >
      <div className="relative">
        {/* Main Badge */}
        <div className="w-20 h-20 bg-gradient-to-br from-secondary-500 via-primary-500 to-accent-500 rounded-full flex items-center justify-center shadow-lg border-4 border-white">
          {/* Halal Symbol */}
          <div className="text-center">
            <motion.div
              className="text-white font-bold text-xs mb-1"
              variants={textVariants}
            >
              حلال
            </motion.div>
            <motion.div
              className="text-white font-bold text-xs"
              variants={textVariants}
            >
              HALAL
            </motion.div>
          </div>
          
          {/* Checkmark */}
          <motion.svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            className="absolute bottom-1"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ delay: 1.5, duration: 0.8 }}
          >
            <motion.path
              d="M3 8 L6 11 L13 4"
              stroke="white"
              strokeWidth="2"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </motion.svg>
        </div>

        {/* Ribbon */}
        <motion.div
          variants={ribbonVariants}
          className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 bg-accent-500 text-white text-xs px-3 py-1 rounded-full font-semibold shadow-md origin-left"
        >
          CERTIFIED
        </motion.div>

        {/* Glow Effect */}
        <motion.div
          className="absolute inset-0 rounded-full bg-gradient-to-br from-secondary-400 via-primary-400 to-accent-400 opacity-30 blur-md"
          animate={{
            scale: [1, 1.2, 1],
            opacity: [0.3, 0.6, 0.3]
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            delay: 2
          }}
        />
      </div>
    </motion.div>
  );
};

export default HalalCertificationBadge;